import react from 'react'
import {Link } from 'react-router-dom'
import Sadam from './../../images/ceo_replace.PNG'



const Third_Pane = () => (
                  <div className='uk-margin-xlarge-top'>

                          <div className='container'>
                          <div className="row  ">
                              <div className='borderRec'>

                                      <div className='row'>
                                            <div className='col-sm-4'>
                                            
                                            </div>

                                            <div className='col-sm-8'>
                                                <div className='uk-padding'>
                                            <h3 className='uk-text-bold'>We work together as a passionate group, creating amazing designs and luxurius spaces.</h3>
                                            <p className='uk-margin-medium-top'>We pride ourselves in providing a win-win investment for our partners with our unique 
                                                experience in infrastructure; international business solutions and procurement.  </p>

                                                <p>We are renowned for our impressive small but growing portfolio and have gained
                                                     a good reputation because we deliver a service that speaks integrity and 
                                                     professionalism.</p>
                                                 
                                       <div className='uk-margin-medium-top '  uk-scrollspy="cls: uk-animation-slide-top; repeat: true">
                                            <Link to="/team" className=' ctaBtn'>Meet the team</Link></div>
                                                 </div>   
                                               </div>
                                      </div>
                              </div>   </div>



                          <div className="row  ">
                              <div className='col-sm-5'   uk-scrollspy="cls: uk-animation-fade; repeat: true">

                                  <div className='sadam'
                                    style={{ backgroundImage: `url(${Sadam})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover',
                                    paddingBottom: '50px',
                                    paddingTop: '100px',
                                    height: '70vh',
                                    borderRadius:'10px'
                                }}
                                  >

                                  </div>
                              </div>

                              <div className='col-sm-7'>
                                  <div className=''
                                       
                                  
                                  >
                              
                                  </div>
                              </div>
                          </div>
                          </div>





                  </div>
)


export default Third_Pane
